import React from 'react';
import OverlayLoader from './OverlayLoader';

const Loader = ({ text = "Loading..." }) => {
  return <OverlayLoader text={text} />;
};

export default Loader;
